module.exports = __webpack_public_path__ + "static/media/MentorBernard.57176613.jpg";